import {Button, ResponsiveContainer, Typography} from "@emburse/ui-core";
import {useTranslation} from "react-i18next";
import {useNavigate} from 'react-router';
import {SharedRouteLink} from "shared/enums";

export const NotFoundError = () => {
    const {t} = useTranslation();
    const navigate = useNavigate();

    return (
        <ResponsiveContainer align="center"
                             size="fullWidth"
                             data-qa="not-found-page"
                             sx={{paddingTop: '65px'}}>
            <Typography variant="body1"
                        data-qa='not-found-message'
                        style={{fontSize: "1.5rem", marginBottom: "2rem"}}>{t('notFoundMessage')}</Typography>
            <Button data-qa='go-home-button' onClick={() => navigate(SharedRouteLink.Home)}>{t('goHome')}</Button>
        </ResponsiveContainer>
    );
};